var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"hidden-md-and-up",attrs:{"fluid":"","align":"center"}},[_c('keyword-search')],1),_vm._v(" "),_c('v-divider')],1)}
var staticRenderFns = []

export { render, staticRenderFns }